import { useMemo } from 'react'
import { Fingerprint, FileWarning, ShieldCheck } from 'lucide-react'
import type { AdminColumn } from '@/components/DataTable/types'
import { ModListScreen } from './ModListScreen'
import { makeFetcher, MOD_STR as S, type HashRow, type FileHashRow, type WhitelistRow } from './modContentApi'

/**
 * A6.26 — Hash bazasi (ma'lum zararli kontent). Aniq-hash blocklisti
 * (GET /admin/moderation/hashes) — perceptual emas (bu A6.27, ML skelet).
 */
export function HashDatabaseScreen() {
  const columns = useMemo<AdminColumn<HashRow>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id' },
      { key: 'hash', header: S.hash, type: 'text' },
      { key: 'hash_type', header: S.hashType, type: 'text' },
      { key: 'category', header: S.category, type: 'text' },
      { key: 'source', header: S.source, type: 'text' },
      { key: 'added_by', header: S.addedBy, type: 'text' },
      { key: 'created_at', header: S.created, type: 'date' },
    ],
    [],
  )
  return (
    <ModListScreen<HashRow>
      screenId="A6.26"
      title={S.hashes}
      description={S.hashesDesc}
      columns={columns}
      fetcher={makeFetcher<HashRow>(
        '/admin/moderation/hashes',
        'hashes',
        (r) => `${r.hash} ${r.category} ${r.source}`,
      )}
      rowId={(r) => String(r.id)}
      icon={<Fingerprint size={28} strokeWidth={1.5} />}
    />
  )
}

/**
 * A6.31 — Fayl hash qora ro'yxati (zararli APK reyestri). SHA-256 bo'yicha
 * (GET /admin/moderation/file-hashes).
 */
export function FileHashBlacklistScreen() {
  const columns = useMemo<AdminColumn<FileHashRow>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id' },
      { key: 'sha256', header: S.hash, type: 'text' },
      { key: 'filename', header: S.filename, type: 'text' },
      { key: 'kind', header: S.kind, type: 'text' },
      { key: 'threat', header: S.threat, type: 'text' },
      { key: 'added_by', header: S.addedBy, type: 'text' },
      { key: 'created_at', header: S.created, type: 'date' },
    ],
    [],
  )
  return (
    <ModListScreen<FileHashRow>
      screenId="A6.31"
      title={S.fileHashes}
      description={S.fileHashesDesc}
      columns={columns}
      fetcher={makeFetcher<FileHashRow>(
        '/admin/moderation/file-hashes',
        'hashes',
        (r) => `${r.sha256} ${r.filename} ${r.threat}`,
      )}
      rowId={(r) => String(r.id)}
      icon={<FileWarning size={28} strokeWidth={1.5} />}
    />
  )
}

/**
 * A6.32 — Oq ro'yxatlar (false-positive'ni oldini olish). Ishonchli domen /
 * user / so'z / hash (GET /admin/moderation/whitelists).
 */
export function WhitelistsScreen() {
  const columns = useMemo<AdminColumn<WhitelistRow>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id' },
      { key: 'value', header: S.value, type: 'text' },
      { key: 'kind', header: S.kind, type: 'text' },
      { key: 'reason', header: S.reason, type: 'longtext' },
      { key: 'added_by', header: S.addedBy, type: 'text' },
      { key: 'created_at', header: S.created, type: 'date' },
    ],
    [],
  )
  return (
    <ModListScreen<WhitelistRow>
      screenId="A6.32"
      title={S.whitelists}
      description={S.whitelistsDesc}
      columns={columns}
      fetcher={makeFetcher<WhitelistRow>(
        '/admin/moderation/whitelists',
        'items',
        (r) => `${r.value} ${r.kind} ${r.reason}`,
      )}
      rowId={(r) => String(r.id)}
      icon={<ShieldCheck size={28} strokeWidth={1.5} />}
    />
  )
}
